import {
    IconDefinition,
    findIconDefinition,
    IconName
} from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Block, Col, Row, Grid } from 'jsxstyle';
import * as React from 'react';
import { SemiBold, Regular } from './Styling';

interface AppBoxProps {
    backgroundColor: string;
    icon: IconDefinition;
    title: string;
    active: boolean;
    mode: 'large' | 'small';
}

class AppBox extends React.Component<AppBoxProps, {}> {
    public render() {
        let { mode } = this.props;
        let style = {
            width: mode == 'large' ? 160 : 120,
            height: mode == 'large' ? 160 : 120,
            opacity: this.props.active ? 1.0 : 0.3,
            cursor: this.props.active ? 'inherit' : 'not-allowed'
        };
        return (
            <Col
                justifyContent="center"
                alignItems="center"
                backgroundColor={this.props.backgroundColor}
                color="white"
                style={style}
            >
                <FontAwesomeIcon
                    icon={this.props.icon}
                    color="white"
                    size="3x"
                />
                <Block marginTop={10}>
                    {mode === 'large' ? (
                        <SemiBold>{this.props.title}</SemiBold>
                    ) : (
                        <Regular>{this.props.title}</Regular>
                    )}
                </Block>
            </Col>
        );
    }
}

export interface Application {
    url: string;
    iconClass: string;
    name: string;
    backgroundColor: string;
    active: boolean;
}

export interface ApplicationsProps {
    applications: Application[];
    mode: 'large' | 'small';
}

export class Applications extends React.Component<ApplicationsProps, {}> {
    render() {
        const applications = this.props.applications;
        let apps = applications.map((a, index) => {
            let last = index === applications.length - 1;
            let [prefix, name] = a.iconClass.split(' ');
            let icon = findIconDefinition({
                iconName: name.replace('fa-', ''),
                prefix: prefix
            } as any);
            let app = (
                <Block key={a.name} marginRight={last ? 0 : 10}>
                    <AppBox
                        mode={this.props.mode}
                        title={a.name.toUpperCase()}
                        icon={icon}
                        backgroundColor={a.backgroundColor}
                        active={a.active}
                    />
                </Block>
            );
            if (a.active) {
                return (
                    <a
                        key={a.name}
                        href={a.url}
                        style={{ textDecoration: 'none' }}
                    >
                        {app}
                    </a>
                );
            }
            return app;
        });

        let size = this.props.mode === 'large' ? 160 : 120;
        let spacing = this.props.mode === 'large' ? 16 : 8;
        return (
            <Grid
                style={{
                    gridTemplateColumns: `${size}px ${size}px ${size}px`,
                    gridTemplateRows: `${size}px ${size}px`,
                    gridRowGap: spacing,
                    gridColumnGap: spacing
                }}
            >
                {apps}
            </Grid>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Applications.tsx